import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import * as userActions from "../../redux/User/actions";
import "./InactivityScreen.scss";
import constants from "../../utils/constants";

const InactivityScreen = () => {
  const [showWarning, setShowWarning] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [lastActivity, setLastActivity] = useState(Date.now());
  const [isActive, setIsActive] = useState(true);
  const dispatch = useDispatch();

  const INACTIVITY_TIMEOUT =
    process.env.REACT_APP_INACTIVITY_TIMEOUT * 60 * 1000; // X minute
  const REDIRECT_COUNTDOWN = process.env.REACT_APP_REDIRECT_COUNTDOWN * 60; // X minute countdown

  useEffect(() => {
    const resetTimer = () => {
      setLastActivity(Date.now());
      setIsActive(true);
      if (showWarning) {
        setShowWarning(false);
        setCountdown(REDIRECT_COUNTDOWN);
      }
    };

    const events = [
      "mousedown",
      "mousemove",
      "keypress",
      "scroll",
      "touchstart",
    ];
    events.forEach((event) => document.addEventListener(event, resetTimer));

    const inactivityCheck = setInterval(() => {
      const now = Date.now();
      if (now - lastActivity >= INACTIVITY_TIMEOUT) {
        if (isActive) {
          setIsActive(false);
          setShowWarning(true);
          setCountdown(REDIRECT_COUNTDOWN);
        }
      }
    }, 1000);

    const onSignout = () => {
      dispatch(userActions.signOut(singOutDone));
    };

    const countdownTimer = setInterval(() => {
      if (showWarning && countdown > 0) {
        setCountdown((prev) => prev - 1);
      }
      if (countdown === 0 && showWarning) {
        onSignout();
      }
    }, 1000);

    // Cleanup
    return () => {
      events.forEach((event) =>
        document.removeEventListener(event, resetTimer)
      );
      clearInterval(inactivityCheck);
      clearInterval(countdownTimer);
    };
  }, [
    showWarning,
    lastActivity,
    countdown,
    isActive,
    REDIRECT_COUNTDOWN,
    INACTIVITY_TIMEOUT,
    dispatch,
  ]);

  // Format countdown time
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

  if (!showWarning) return null;

  const singOutDone = () => {
    const isInternalLogin =
      localStorage.getItem(constants.IS_INTERNAL_LOGIN) === "true";

    if (isInternalLogin) {
      window.location.href = "/internal";
      localStorage.setItem(constants.IS_INTERNAL_LOGIN, "false");
    }
  };

  return (
    <div className="inactivity-overlay">
      <div className="inactivity-modal">
        <div className="modal-content">
          <h2 className="modal-title">Inactivity Warning</h2>
          <div>
            <p className="modal-message">
              You have been inactive for{" "}
              {process.env.REACT_APP_INACTIVITY_TIMEOUT} minutes. Due to
              security reasons, you will be redirected to the login page in:
            </p>
            <div className="countdown">{formatTime(countdown)}</div>
            <p className="warning-message">
              Move your mouse or press any key to continue your session.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InactivityScreen;
